import printJS from 'print-js'

export const openPrint = printTargetClasses => {
  const printArea = document.getElementById("print");

  document.querySelectorAll("body *").forEach(value => {
    if (value.id != "print") {
      value.classList.add("print-off");
    }
  });

  let targets = document.querySelectorAll(printTargetClasses);
  targets.forEach(value => {
    printArea.appendChild(value.cloneNode(true));
  });
  document.querySelectorAll("#print *").forEach(value => {
    value.classList.remove("print-off");
  });

  window.print();
  printArea.textContent = null;
  document.querySelectorAll("body *").forEach(value => {
    value.classList.remove("print-off");
  });
};


export const printImage = src => {
  printJS(src, 'image')
}

export const printPdf = src => {
  printJS({printable: src.replace(/^data:application\/pdf;base64,/, ''), base64 : true})
}

export default {
  openPrint,
  printImage,
  printPdf,
};
